<template>
  <sl-side-panel v-model="modalVisible" :mask-closable="false" :title="itemTitle">
    <Form class="sm" ref="form" :model="form" :rules="rules" :label-width="100">
      <FormItem label="车辆类型" prop="categoryId">
        <sl-select dict="carcate" v-model="form.categoryId" />
      </FormItem>
      <FormItem label="车辆品牌" prop="brand">
        <Input v-model="form.brand" :maxlength="64"></Input>
      </FormItem>
      <FormItem label="电机号" prop="motorNo">
        <Input v-model="form.motorNo" :maxlength="64"></Input>
      </FormItem>
      <FormItem label="车架号" prop="frameNo">
        <Input v-model="form.frameNo" :maxlength="64"></Input>
      </FormItem>
      <FormItem label="车辆编号" prop="carNo">
        <Input v-model="form.carNo" :maxlength="64" :disabled="isEdit"></Input>
      </FormItem>
      <FormItem label="IMEI" prop="imei">
        <Input v-model="form.imei" :maxlength="64"></Input>
      </FormItem>
      <FormItem label="电池类型" prop="battery.type">
        <sl-select dict="$$battery_type" v-model="form.battery.type" />
      </FormItem>
      <FormItem label="电池电压" prop="battery.voltage">
        <sl-select dict="$$voltage" v-model="form.battery.voltage" />
      </FormItem>
      <FormItem label="电池电量" prop="battery.electricity">
        <sl-select dict="$$electricity" v-model="form.battery.electricity" />
      </FormItem>
      <FormItem label="电池序号" prop="battery.batteryNo">
        <Input v-model="form.battery.batteryNo" :maxlength="64"></Input>
      </FormItem>
      <FormItem label="电池规格" prop="battery.specs">
        <Input v-model="form.battery.specs" :maxlength="64"></Input>
      </FormItem>
      <FormItem label="电池品牌" prop="battery.brand">
        <Input v-model="form.battery.brand" :maxlength="64"></Input>
      </FormItem>
      <FormItem label="车牌号" prop="carNo">
        <Input v-model="form.license.licenseNo" :maxlength="64"></Input>
      </FormItem>

      <FormItem label="登记时间" prop="entryTime">
        <DatePicker type="date" v-model="form.enrollDatetime"></DatePicker>
      </FormItem>
      <FormItem label="保单号" prop="insurance.insuranceNo">
        <Input v-model="form.insurance.insuranceNo" :maxlength="64"></Input>
      </FormItem>
      <FormItem label="保险公司" prop="insurance.insuranceCompanyName">
        <Input v-model="form.insurance.insuranceCompanyName" :maxlength="64"></Input>
      </FormItem>

      <FormItem label="备注" prop="remark">
        <Input type="textarea" :autosize="{minRows: 5,maxRows: 8}" v-model="form.remark"></Input>
      </FormItem>
    </Form>
    <div slot="footer">
      <Button :loading="loading" @click="handleSubmit('form')" type="primary">确定</Button>
    </div>
  </sl-side-panel>
</template>
<script>

import detail from '../info/detail'

export default {
  mixins: [detail],
  data(){
    return {
      api:{
        query:'car',
        // query:'carStock',
        create:'carStockCreate',
        update:'carStockUpdate'
      }
    }
  }
}

</script>
